import React from 'react';
import ImageTile from '../../../assets/icons/image-tile';
import css from './new-theme-header.module.scss';
import BuilderThemeIllustration from '../../../assets/images/builder-theme-illustration';

type Props = {
  alt: string;
  color: string;
  logo: string;
  logoBackgroundColor: string;
  isBuilder: boolean;
};

const NewThemeHeader = ({
  logo,
  color,
  alt,
  logoBackgroundColor,
  isBuilder,
}: Props) => {
  const themeColor = color ? `#${color}` : '';

  return (
    <div className={css.themeHeader}>
      <div className={css.themeHeaderIllustration}>
        {<BuilderThemeIllustration color={themeColor} />}
      </div>
      {(isBuilder || logo) && (
        <div
          className={css.builderLogo}
          style={{ backgroundColor: logoBackgroundColor }}
          data-testid="logo-background"
        >
          {logo ? (
            <img
              alt={alt}
              className={css.imageLogo}
              data-testid="logo-image"
              src={logo}
            />
          ) : (
            // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339
            <ImageTile className={css.builderDefaultIcon} />
          )}
        </div>
      )}
    </div>
  );
};

export { NewThemeHeader };
export default NewThemeHeader;
